import React from "react";

export default function ServerPagination({
  currentPage,
  rowsPerPage,
  totalRows,
  onPageChange,
  onRowsPerPageChange,
  pageSizeOptions = [10, 20, 50, 100],
}) {
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page, rowsPerPage);
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 bg-white">
      {/* Rows per page */}
      <div className="d-flex align-items-center gap-2">
        <span>Rows per page:</span>
        <select
          className="form-select form-select-sm"
          style={{ width: 90 }}
          value={rowsPerPage}
          onChange={(e) =>
            onRowsPerPageChange(Number(e.target.value), 1)
          }
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      {/* Page info */}
      <div className="text-muted">
        Page <strong>{currentPage}</strong> of{" "}
        <strong>{totalPages ? totalPages : 0}</strong> ({totalRows} records)
      </div>

      {/* Pagination buttons */}
      <div className="btn-group">
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === 1}
          onClick={() => goToPage(1)}
        >
          «
        </button>
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === 1}
          onClick={() => goToPage(currentPage - 1)}
        >
          ‹
        </button>

        <button className="btn btn-sm btn-primary" disabled>
          {currentPage}
        </button>

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === totalPages}
          onClick={() => goToPage(currentPage + 1)}
        >
          ›
        </button>
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === totalPages}
          onClick={() => goToPage(totalPages)}
        >
          »
        </button>
      </div>
    </div>
  );
}
